<template>
  <h1 class="mb-4">{{ title }}</h1>
  <slot></slot>
</template>

<script setup lang="ts">

interface Props {
  title: string
}

defineProps<Props>()

</script>
